import React from 'react';
import { Box, Button, Container, Typography, } from '@mui/material';
import HeroImage from '../../assets/images/hero_image.png';
import '../../App.css';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
    const navigate = useNavigate();
    return (
        <Box
            component="section"
            sx={{
                position: 'relative',
                minHeight:
                    '600px',
                py: { xs: 8, md: 0 },
                overflow: 'hidden',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                background: `url(${HeroImage}) center / cover no-repeat`,
                '@media (min-width: 1024px)': {
                    background: `url(${HeroImage}) right center / cover no-repeat`,
                    minHeight: '700px',
                    maxWidth: '1440px',
                    mx: 'auto',
                },
            }}
        >
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
                <Box sx={{ maxWidth: { xs: '100%', md: '640px', lg: '700px', } }}>
                    <Typography
                        variant="h1"
                        className="hero-title hero-anim-title"
                        sx={{
                            fontSize: { xs: '2.3rem', sm: '2.5rem', md: '2.8rem', lg: '3.5rem' },
                            mb: 3.5,
                        }}
                    >
                        Money Should Move<br />Like Information
                    </Typography>

                    <Typography
                        variant="body1"
                        className="hero-desc hero-anim-desc"
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.05rem', md: '1.1rem' },
                            maxWidth: { md: '560px' },
                            mb: 2,
                        }}
                    >
                        Payible enables instant, non-custodial fiat-to-crypto conversion for individuals and businesses.
                    </Typography>

                    <Box
                        className="hero-anim-btns"
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: { xs: 4, sm: 3, md: 4 },
                            mt: 4,
                        }}
                    >
                        {/* Column 1 */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', width: { xs: '100%', sm: '240px', md: '250px' } }}>
                            <Button
                                variant="contained"
                                id="hero-btn-get-started"
                                className="hero-btn-primary"
                                onClick={() => navigate('/contact')}
                                sx={{
                                    fontSize: '1rem',
                                    textTransform: 'none',
                                    py: 1.8,
                                    px: 4,
                                    width: '100%',
                                }}
                            >
                                Get Started
                            </Button>
                            <Typography
                                className="hero-btn-label"
                                sx={{
                                    fontSize: '0.85rem',
                                    mt: 2,
                                    px: 0.5,
                                }}
                            >
                                Buy and sell cryptocurrency with fast, non-custodial OTC execution.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Box >
    );
};

export default HeroSection;
